import {extendTheme} from "@chakra-ui/react";

const styles = {
    global: {
        html: {
            fontSize: "18px",
        },
    },
};

const components = {};

const fonts = {
    body: "Rubik",
    heading: "Rubik",
};

const colors = {
    lightGrey: "hsl(0, 0%, 59%)",
    lightGreyOpacity: "hsl(0, 0%, 59%, 40%)",
    darkGrey: "hsl(0, 0%, 17%)",
};

const config = {
    initialColorMode: "light",
    useSystemColorMode: false,
};

const theme = extendTheme({config, styles, components, colors, fonts});

export default theme;
